import React, { useContext, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useLocation, useParams } from "react-router";
import authService from "../../services/AuthService";

const VerifyTokenCode = () => {
  const history = useHistory();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const verificationToken = searchParams.get("code");

  const verificationProcess = async () => {
    try {
      const request = await authService
        .verifyToken({ verificationToken })
        .then((response) => {
          if (response.message != "Success!") {
            history.push("/login");
          } else {
            history.push("/reset-password?code=" + verificationToken);
          }
        });
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    verificationProcess();
  }, []);

  return <div className="verify-token">Verification Loading</div>;
};

export default VerifyTokenCode;
